import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { returnMessageFailApi } from '../../shared/helpers/api-response-message';
import { getUserFromJwtCookie } from '../../shared/helpers/getUserCookie';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable()
export class Interceptor implements HttpInterceptor {
  private _injector: Injector;
  private key = CryptoJS.enc.Utf8.parse('getyouraws100certificateB$tch123');

  constructor(
    injector: Injector,
  ) {
    this._injector = injector;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const useCookie = environment.jwtCookieName;
    const token = getUserFromJwtCookie(useCookie);

    const iv = CryptoJS.lib.WordArray.random(16);
    const payload = JSON.stringify(req.body);
    const encrypted = CryptoJS.AES.encrypt(payload, this.key, { iv }).ciphertext.toString(CryptoJS.enc.Base64);
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

    const clonedRequest = req.clone({
      body: { payload: encrypted },
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'x-iv': ivBase64,
      }
    });

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        const router = this._injector.get(Router); // avoid circular dependency

        if (
          error.status === 403 &&
          error.error &&
          typeof error.error === 'object' &&
          error.error.message === 'User is not authorized to access this resource with an explicit deny'
        ) {
          router.navigate(['/no-autorizado']);
        }

        let customError: any = error;
        customError.message = returnMessageFailApi(error);

        return throwError(customError);
      })
    );
  }
}

